import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-focus"
export default class extends Controller {
  static targets = ["input"]

  connect() {
    this.focusInput()
  }

  focusInput() {
    if (this.hasInputTarget) {
      // Use setTimeout to ensure the element is fully rendered
      setTimeout(() => {
        this.inputTarget.focus()
        this.inputTarget.select()
      }, 100)
    }
  }

  // Method to be called after turbo stream updates
  turboStreamRendered() {
    this.focusInput()
  }
}